import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=0cb88efa&scoped=true&"
import script from "./plan-detail.vue?vue&type=script&lang=js&"
export * from "./plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=0cb88efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb88efa",
  null
  
)

export default component.exports